import React from "react";

import { ISummary } from "../../../../interface/IActivitiesManagementSummary";
import { IContent } from "../../../../interface/IActivitiesManagementModal";
import SummaryStyles from "../../../../../../styles/pages/Workflows/ActivitiesManagementSummaryStyles";
import ButtonStyles from "../../../../../../styles/components/ButtonStyles";

const { DefaultButtonLink } = ButtonStyles;

interface ISummaryProps {
    summary: ISummary;
    handleChangeContent: (content: IContent) => void;
}

const SummaryList: React.FC<ISummaryProps> = ({
    summary,
    handleChangeContent,
}) => {
    return (
        <SummaryStyles.StyledTable>
            <tbody>
                <tr>
                    <SummaryStyles.StyledTableTitle colSpan={2}>
                        Horas Programadas Realizadas
                    </SummaryStyles.StyledTableTitle>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Letivas
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.letivasRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Não Letivas
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.naoLetivasRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableSubtitle colSpan={2}>
                        Antecipações, Reposições e Substituições Realizadas
                    </SummaryStyles.StyledTableSubtitle>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Antecipações
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.antecipacaoRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Reposições
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.reposicaoRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Substituições
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.substituicaoRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableSubtitle colSpan={2}>
                        Horas Não Realizadas
                    </SummaryStyles.StyledTableSubtitle>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Letivas
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.letivasNaoRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Não Letivas
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.naoLetivasNaoRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Antecipações
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.antecipacaoNaoRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Reposições
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.reposicaoNaoRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Substituições
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.substituicaoNaoRealizadas} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableSubtitle colSpan={2}>
                        Resultado Final
                    </SummaryStyles.StyledTableSubtitle>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfoTitle>
                        Total Horas Programadas
                    </SummaryStyles.StyledTableInfoTitle>
                    <SummaryStyles.StyledTableValue>
                        {summary.resultadoFinal?.totalHoraProgramada} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Total Horas Programadas Realizadas
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.resultadoFinal?.totalHoraProgramadaRealizada}{" "}
                        h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Total Horas Programadas Não Realizadas
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValueMarked>
                        {
                            summary.resultadoFinal
                                ?.totalHoraProgramadaNaoRealizada
                        }{" "}
                        h/a
                    </SummaryStyles.StyledTableValueMarked>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Total Horas Antecipações, Reposições e Substituições
                        Realizadas
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.resultadoFinal?.totalHoraEspecialRealizada} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableInfo>
                        Saldo Final de Horas
                    </SummaryStyles.StyledTableInfo>
                    <SummaryStyles.StyledTableValue>
                        {summary.resultadoFinal?.saldoFinalHoras} h/a
                    </SummaryStyles.StyledTableValue>
                </tr>
                <tr>
                    <SummaryStyles.StyledTableLink colSpan={2}>
                        <DefaultButtonLink
                            onClick={() => handleChangeContent("DETAILS")}
                        >
                            Ver Atividades
                        </DefaultButtonLink>
                    </SummaryStyles.StyledTableLink>
                </tr>
            </tbody>
        </SummaryStyles.StyledTable>
    );
};

export default SummaryList;
